<template>
  <div>
    <el-form
      class="change-person-info"
      ref="personForm"
      :model="form"
      label-width="80px"
    >
      <el-form-item label="账号">
        <el-input
          v-model="form.F_Account"
          placeholder="请输入账号"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="姓名" required="">
        <el-input
          v-model="form.F_RealName"
          placeholder="请输入姓名"
          ref="nickName"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="昵称" required>
        <el-input
          v-model="form.F_NickName"
          placeholder="请输入昵称"
          ref="nickName"
        >
        ></el-input>
      </el-form-item>
      <el-form-item label="性别" style="text-align: left">
        <el-radio-group v-model="form.GenderName">
          <el-radio label="男" value="男">男</el-radio>
          <el-radio label="女" value="女">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="requestModifyInfo">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {
  getPersonalInfo,
  modifyPersonalInfo,
  USER_SETTING,
} from '@/api/personal-center/setting';
import { BASE_URL } from '@/utils/request/request';

export default {
  name: 'change-personInfo',
  data() {
    return {
      nickEditable: 'disabled',
      baseUrl: BASE_URL,
      settingUrl: USER_SETTING,
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: '',
      info: {},
      form: {
        avatarUrl: '',
        name: '',
        gender: 1,
        contact: '13567894514',
      },
    };
  },
  created() {
    this.requestPersonalInfo();
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId;
    },
    basePropList() {
      const list = [...this.baseInfoProps.keys()];
      const arr = [];
      for (let i = 0; i < list.length; i += 3) {
        arr.push(list.slice(i, i + 3));
      }
      return arr;
    },
    hintPhone() {
      const arr = this.info.F_MobilePhone.split('');
      arr.splice(2, arr.length - 3, '*******');
      return arr.join('');
    },
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        console.log('newVal', newVal);
      },
    },
  },
  methods: {
    requestModifyInfo() {
      const formData = new FormData();
      formData.append('RealName', this.form.F_RealName);
      formData.append('NickName', this.form.F_NickName);
      formData.append('Gender', this.form.GenderName === '男' ? 1 : 0);
      modifyPersonalInfo(formData, {
        UIDstr: this.accountId,
      })
        .then((res) => {
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          setTimeout(() => {
            this.$emit('changeResult', 1);
          }, 2000);
          console.log(res);
        })
        .catch(() => {
          this.$message({
            message: '失败',
            type: 'warning',
          });
        });
    },
    requestPersonalInfo() {
      getPersonalInfo({
        UIDstr: this.accountId,
      }).then((res) => {
        [this.info] = res.list;
        this.form = { ...this.info };
      });
    },
  },
};
</script>
<style scoped>
</style>
